// extracted by mini-css-extract-plugin
module.exports = {"open":"styles_open__3MfH6","partial":"styles_partial__2pEPh","closed":"styles_closed__2QlIG"};